import { render, staticRenderFns } from "./PageIntegration.vue?vue&type=template&id=64ef001b&"
import script from "./PageIntegration.vue?vue&type=script&lang=js&"
export * from "./PageIntegration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports